module.exports = __webpack_public_path__ + "img/notifications.49a10681.svg";